// extracted by css-extract-rspack-plugin
export default {"box":"Spinner-module__box___y0flj","row":"Spinner-module__row___RCWz7","ring":"Spinner-module__ring___DvhYm","spin":"Spinner-module__spin___wR26e"};